[<template>
  <div>
    <h1 class="capitalize">{{ directory }}</h1>
    <div class="image-format">
      <div v-for="(p, i) in files" :key="i" class="image-div">
        <div v-for="(a, b) in p" :key="b">
        <el-image v-if="b == 'name'"
          class="image pointer"
          :src="`${url}${directory}/${a}`"
          @dblclick="click(a)"
        ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('fileManager', ['files', 'directory'])
  },

  data() {
    return {
      copyText: '',
      url: process.env.VUE_APP_STORAGE_URL
    }
  },

  methods: {
    click(image) {
      this.copyText = this.url + this.directory + '/' + image
      this.copyTextToClipboard(this.copyText)
    },

    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text)
        return
      }
      navigator.clipboard.writeText(text).then(
        () => {
          this.$message({
            type: 'success',
            message: 'Copied the link: ' + text
          })
          console.info('Async: Copying to clipboard was successful!')
        },
        err => {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement('textarea')
      textArea.value = text

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        if (msg == 'successful') {
          this.$message({
            type: 'success',
            message: 'Copied the link: ' + text
          })
        }
        console.info('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }

      document.body.removeChild(textArea)
    }
  }
}
</script>

<style scoped>
.image-format {
  border-radius: 15px;
}
.image {
  width: 200px;
  height: 200px;
  border-radius: 15px;
}
.image-div {
  display: inline-block;
  margin-left: 5px;
}
</style>
